import posthog from "posthog-js"

/**
 * Identifies the user in PostHog.
 * @param userId - The unique identifier for the user.
 * @param traits - An object containing user properties (e.g., email, name).
 */

export const identifyUser = (userId: string, traits: Record<string, any>) => {
  try {
    posthog?.identify(userId, traits)
    console.log("[Analytics] Identified user in PostHog:", userId, traits)
  } catch (error) {
    console.error("[Analytics] Error identifying user in PostHog:", error)
  }
}

/**
 * Tracks an event in PostHog.
 * @param eventName - The name of the event to track.
 * @param properties - An optional object containing event properties.
 */

export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  try {
    posthog?.capture(eventName, properties)
    console.log("[Analytics] Tracked event in PostHog:", eventName, properties || "")
  } catch (error) {
    console.error("[Analytics] Error tracking event in PostHog:", error)
  }
}

/**
 * Tracks a page view event.
 * @param pageName - The name of the page viewed.
 * @param properties - Additional properties for the page view event.
 */

export const trackPageView = (pageName: string, properties?: Record<string, any>) => {
  const currentUrl = window.location.href
  const posthogProperties = { ...properties, $current_url: currentUrl }

  try {
    posthog?.capture("$pageview", posthogProperties)
    console.log("[Analytics] Tracked $pageview in PostHog:", posthogProperties)
  } catch (error) {
    console.error("[Analytics] Error tracking $pageview in PostHog:", error)
  }
}

export const initTracking = () => {
  // PostHog is already initialized in main.tsx
}

/**
 * Resets the tracking identification for PostHog.
 * Typically called on user logout.
 */
export const resetTracking = () => {
  try {
    // posthog?.reset()
    console.log("[Analytics] PostHog reset.")
  } catch (error) {
    console.error("[Analytics] Error resetting PostHog:", error)
  }
}
